(function () {

  'use strict';

  function pxSiteContextDialog(
    $rootScope, $filter, $translate, localStorageService, $cookies, $timeout, $window
    ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        additionalContent: '=additionalContent',
        selectedTab: '=selectedTab',
        contextContentPosition: '=contextContentPosition',
        callback: '&callback',
        auxiliaries: '=auxiliaries',
        isThisSiteMine: '=isThisSiteMine'
      },
      // TEMPLATE USAGE -> px-site-context-dialog // only used inside of /sites path - THIS IS APPROVED
      templateUrl: 'app/components/sites/_siteContextDialog/siteContextDialog.template.html',
      link: function (scope, element, attrs) {

        (function() {
          initContexContent();
        })();

        scope.$watch(function() {
          return scope.contextContentPosition;
        }, function(oldVal, newVal){
          if (oldVal !== newVal) {
            initContexContent();
          }
        })

        function initContexContent() {
          checkValidPostion (scope.contextContentPosition.left, scope.contextContentPosition.top)
        };

        function checkValidPostion (left, top) {
          if (scope.contextContentPosition.forceCenter) {
            $timeout(function() {
              var menuHeight = angular.element('.context-content-container').innerHeight();
              var menuWidth = angular.element('.context-content-container').innerWidth();


              var screenVertCenter = $window.innerHeight / 2;
              var menuVerticalCenter = menuHeight / 2;
              top = screenVertCenter - menuVerticalCenter;

              var screenHorCenter = window.innerWidth / 2
              var menuHorizontalCenter = menuWidth / 2;

              left = screenHorCenter - menuHorizontalCenter;


              angular.element('.context-content-container').css({left: left , top: top});
              angular.element('.context-content-container').css({display: 'block'});
            }, 50)
          } else {

            var offsetX = 60;
            var offsetY = 100;

            left = left - offsetX;
            var containerWidth = angular.element('.container').innerWidth();

            $timeout(function() {
              var menuHeight = angular.element('.context-content-container').innerHeight();
              var menuWidth = angular.element('.context-content-container').innerWidth();



              if ($window.innerHeight <= 768) {
                var screenCenter = $window.innerHeight / 2;
                var menuCenter = menuHeight / 2;
                top = screenCenter - menuCenter;
              } else if ((menuHeight + top) > $window.innerHeight) {
                top = ($window.innerHeight - menuHeight) / 2;
              } else {
                top = top - offsetY;
              }

              if (containerWidth <= 1024) {
                var screenCenter = containerWidth / 2
                var menuCenter = menuWidth / 2;
                left = screenCenter - menuCenter;

              } else if ((menuWidth + left) > containerWidth) {
                left = left - menuWidth;
              }

              angular.element('.context-content-container').css({left: left , top: top});
              angular.element('.context-content-container').css({display: 'block'});
            }, 50)
          }

        }

        scope.outsideClickCloseDialog = function (bypass) {
          if (!bypass) {
            scope.callback({context: false});
          }
        }

        scope.closePopup = function (meta) {
          if (meta) {
            scope.callback({selectedContextMenuItem: meta, contextContentPosition: scope.contextContentPosition, contextContent: { context: scope.context}});
          } else {
            scope.callback({selectedContextMenuItem: null, contextContentPosition: null, contextContent: null});
          }
        }

        scope.$on('$destroy', function() {
          angular.element('.context-content-container').css({display: 'none'});
        });

      }
    }
  }



  pxSiteContextDialog.$inject = ['$rootScope', '$filter', '$translate', 'localStorageService', '$cookies', '$timeout', '$window'];

  angular
    .module('printix-admin')
    .directive('pxSiteContextDialog', pxSiteContextDialog);

})();